import get from 'lodash/get'

export const customerReviewListSelector = (state) => get(state, 'customerReview.list')
export const customerReviewIsFetchSelector = (state) => get(state, 'customerReview.isFetch')
export const customerReviewErrorSelector = (state) => get(state, 'customerReview.error')
export const customerReviewHasRequestedSelector = (state) => get(state, 'customerReview.hasRequested', false)
